import { put, select } from 'redux-saga/effects';
import BookingActions from './BookingRedux';
import API from '@utils/api';
import logger from '@utils/logger';
import { transformAvailableDate } from '@services/transform';
import { FREQUENCIES, TIME_FRAME } from '@services/minte';
import { AuthSelectors } from './AuthRedux';

const ALL_TIME_FRAMES = [
  TIME_FRAME.ANYTIME,
  TIME_FRAME.MORNING,
  TIME_FRAME.AFTERNOON
];

export function* initBookingFromClean(action) {
  const { clean, step, initialChanges, isRecurring } = action;

  const {
    bookingID,
    momentServiceDate,
    formattedDate,
    formattedDay,
    serviceType,
    additionalService,
    timeframe,
    property
  } = clean;

  const cleanDate = {
    momentDate: momentServiceDate,
    formattedDate: `${formattedDay} ${formattedDate}`,
    timestamp: momentServiceDate.unix(),
    timeframe,
    ymdString: momentServiceDate.format('YYYY-MM-DD'),
    availableWindow: ALL_TIME_FRAMES
  };

  yield put(
    BookingActions.resetBookingWithState({
      bookingId: bookingID,
      prevStep: '',
      step,
      frequency: isRecurring ? FREQUENCIES.REGULARLY : FREQUENCIES.ONCE,
      serviceType: serviceType.name,
      addons: (additionalService || []).map(addon => addon.name),
      cleanDate,
      property,
      ...initialChanges
    })
  );
}

export function* fetchBookingsData() {
  let singleAvailableDates = [];

  yield put(BookingActions.setAvailableDatesLoading(true));
  const state = yield select();

  const {
    serviceType,
    addons: addOns,
    recipient: recipientInfo,
    property
  } = state.booking;
  const isPM = AuthSelectors.selectIsPMUser(state);
  //need for PM users
  const values = { serviceType, addOns };
  if (isPM && recipientInfo) {
    values.propertyID = recipientInfo.propertyID;
    values.bedroomsCount = recipientInfo.bedroomsCount;
  } else {
    values.propertyID = property.propertyID;
  }

  try {
    const {
      result: { availabilities }
    } = yield API.getAvailableDates(values, isPM);
    singleAvailableDates = availabilities
      .map(item => transformAvailableDate(item))
      .filter(item => !!item);
  } catch (e) {
    logger.log(e);
  }

  yield put(BookingActions.setAvailableDates(singleAvailableDates));
  yield put(BookingActions.setAvailableDatesLoading(false));
}
